(function () {
    window.JN = window.JN || {};
    var root = document.getElementById('search2-omnibox');
    var results = document.querySelector('.search-results');
    if (!root) return;

    var MULTI = {topic: 1, speaks: 1, skill: 1, outlet: 1, profession: 1};
    var SCALAR = {q: 1, place: 1, lat: 1, lng: 1, radius: 1, exact: 1, place_mode: 1};
    // modifiers qualify a content key; alone they are not a search
    var MODIFIERS = {page: 1, exact: 1, place_mode: 1, lat: 1, lng: 1, radius: 1};
    var state = {page: 1};
    var loading = false, exhausted = false, suppressHistory = false;
    var interpProfession = null;
    // localized display name for the current place value (URL keeps the raw value)
    var placeDisplay = null;

    function parseUrl() {
        state = {page: 1};
        var params = new URLSearchParams(window.location.search);
        params.forEach(function (value, key) {
            if (!value) return;
            if (MULTI[key]) (state[key] = state[key] || []).push(value);
            else if (SCALAR[key]) state[key] = value;
        });
    }

    function toParams(extra) {
        var params = new URLSearchParams();
        Object.keys(state).forEach(function (key) {
            if (key === 'page') return;
            if (MULTI[key]) state[key].forEach(function (v) { params.append(key, v); });
            else params.set(key, state[key]);
        });
        Object.keys(extra || {}).forEach(function (k) { params.set(k, extra[k]); });
        return params;
    }

    function esc(text) {
        var div = document.createElement('div');
        div.textContent = text == null ? '' : String(text);
        return div.innerHTML;
    }

    function labelFor(type, value) {
        var el = document.querySelector('[data-filter="' + type + '"][value="' + value + '"]');
        if (el) {
            var span = el.closest('label') && el.closest('label').querySelector('span');
            if (span) return span.textContent.trim();
        }
        return value;
    }

    function renderChips() {
        var row = document.getElementById('chip-row');
        if (!row) return;
        var html = '';
        if (state.q) html += chip('q', state.q, state.q);
        if (state.place) {
            var pName = (placeDisplay && placeDisplay.value === state.place)
                ? placeDisplay.label : state.place;
            var label = state.place_mode === 'covers'
                ? window.JN.t('js.search2.covers_chip').replace('%(place)s', pName)
                : pName;
            html += chip('place', state.place, label);
        }
        Object.keys(MULTI).forEach(function (key) {
            (state[key] || []).forEach(function (v) { html += chip(key, v, labelFor(key, v)); });
        });
        row.innerHTML = html;
    }

    var CHIP_ICONS = {
        place: 'ph:map-pin', topic: 'ph:tag', outlet: 'ph:newspaper',
        speaks: 'ph:translate', skill: 'ph:graduation-cap', q: 'ph:magnifying-glass',
        profession: 'ph:briefcase'
    };

    function chip(type, value, label) {
        var icon = CHIP_ICONS[type];
        return '<span class="pill-link" data-chip-type="' + esc(type) + '" data-chip-value="' + esc(value) + '">' +
            (icon ? '<iconify-icon icon="' + icon + '" class="tw-text-base" aria-hidden="true"></iconify-icon>' : '') +
            '<span>' + esc(label) + '</span>' +
            '<button type="button" class="btn-unstyled" aria-label="' + esc(window.JN.t('js.search2.remove_filter')) + '">&times;</button></span>';
    }

    function updateBookBanner() {
        var link = document.getElementById('book-url');
        var banner = document.getElementById('post_a_job_banner');
        if (!banner) return;
        if (link && link.hasAttribute('href')) {
            var params = new URLSearchParams();
            var topics = (state.topic || []).slice();
            if (state.q) topics.unshift(state.q);
            if (topics.length) params.set('topic_tx', topics.join(', '));
            else if (state.place) params.set('location_tx', state.place);
            if (state.speaks && state.speaks[0]) params.set('language', state.speaks[0]);
            if (state.profession && state.profession[0]) params.set('profession_id', state.profession[0]);
            // mirrors view/search2.py's book_description_tx join
            var description = [topics.join(', '), state.place].filter(Boolean).join(' — ');
            if (description) params.set('description_tx', description);
            link.setAttribute('href', '/book?' + params.toString());
        }
    }

    function fmtCount(n) {
        return Number(n).toLocaleString();
    }

    function updateFacets(facets) {
        var mapping = {skill: ['skill_ids', 'covered_skill_ids'], speaks: ['language_cds'], profession: ['profession_ids']};
        Object.keys(mapping).forEach(function (kind) {
            var list = document.querySelector('[data-facet-list="' + kind + '"]');
            if (!list) return;
            var counts = {};
            mapping[kind].forEach(function (field) {
                (facets[field] || []).forEach(function (f) {
                    var key = String(f.value);
                    counts[key] = Math.max(counts[key] || 0, f.count);
                });
            });
            list.querySelectorAll('[data-facet-value]').forEach(function (row) {
                var value = row.getAttribute('data-facet-value');
                var count = counts[value];
                var badge = row.querySelector('[data-facet-count]');
                var checked = row.querySelector('input').checked;
                if (badge) badge.textContent = count ? fmtCount(count) : '';
                row.style.display = (count || checked) ? '' : 'none';
            });
        });
    }

    function placeLabel(data) {
        return data.place_label || (data.interpretation && data.interpretation.place_label)
            || state.place || '';
    }

    function interpVariant(interp, data) {
        if (!interp) return null;
        // step 2 on a reinterpreted query reads as one sentence, not stacked callouts
        if (data.ladder && data.ladder.step === 2 && interp.place) return 'covered';
        if (interp.q) return 'split';
        if (interp.place) return 'place-only';
        return null;
    }

    function fillTemplate(span, values) {
        var text = span.getAttribute('data-template') || span.textContent;
        span.setAttribute('data-template', text);
        Object.keys(values).forEach(function (k) { text = text.replace('%(' + k + ')s', values[k]); });
        span.textContent = text;
    }

    function showLadder(ladder, data) {
        var banner = document.getElementById('ladder-banner');
        if (!banner) return;
        var step = ladder && ladder.step;
        var show = !!step && step !== 0 && interpVariant(data.interpretation, data) !== 'covered';
        banner.classList.toggle('tw-hidden', !show);
        if (!show) return;
        banner.querySelectorAll('[data-ladder]').forEach(function (span) {
            var active = span.getAttribute('data-ladder') === String(step);
            span.style.display = active ? '' : 'none';
            if (active) fillTemplate(span, {radius: ladder.radius_used || '', place: placeLabel(data)});
        });
    }

    function showPivot(data) {
        var line = document.getElementById('pivot-line');
        if (!line) return;
        var covers = state.place_mode === 'covers';
        var count = covers ? data.based_count : data.covers_count;
        var mode = covers ? 'based' : 'covers';
        // step 2 already rescued to covered results; offering the same switch would confuse
        var laddered = data.ladder && data.ladder.step === 2;
        var show = state.place && !laddered && typeof count === 'number' && count > 0;
        line.classList.toggle('tw-hidden', !show);
        if (!show) return;
        line.querySelectorAll('[data-pivot]').forEach(function (span) {
            var active = span.getAttribute('data-pivot') === mode;
            span.style.display = active ? '' : 'none';
            if (active) fillTemplate(span, {count: fmtCount(count), place: placeLabel(data)});
        });
    }

    function showInterpretation(interp, data) {
        var banner = document.getElementById('interpretation-banner');
        if (!banner) return;
        var variant = interpVariant(interp, data);
        banner.classList.toggle('tw-hidden', !variant);
        if (!variant) return;
        banner.setAttribute('data-q-raw', interp.q_raw || '');
        banner.querySelectorAll('[data-interp]').forEach(function (span) {
            var active = span.getAttribute('data-interp') === variant;
            span.style.display = active ? '' : 'none';
            if (active) fillTemplate(span, {
                q: interp.q || '', place: placeLabel(data), count: fmtCount(data.total_count || 0)
            });
        });
    }

    function showTranslation(tr) {
        var banner = document.getElementById('translation-banner');
        if (!banner) return;
        banner.classList.toggle('tw-hidden', !tr);
        if (!tr) return;
        var span = banner.querySelector('[data-translation]');
        var text = span.getAttribute('data-template') || span.textContent;
        span.setAttribute('data-template', text);
        span.textContent = text.replace('%(q)s', tr.q || '').replace('%(q_raw)s', tr.q_raw || '');
    }

    function setCounter(total, data) {
        var counter = document.querySelector('.result-counter');
        if (!counter) return;
        var label = placeLabel(data);
        var tpl = null;
        // singular falls back to the plain count so we don't need a second grammatical form
        if (state.place && label && total !== 1) {
            var covers = state.place_mode === 'covers' || (data.ladder && data.ladder.step === 2);
            tpl = covers ? counter.dataset.countCovers
                : (data.place_in ? counter.dataset.countBasedIn : counter.dataset.countBased);
        }
        if (tpl) {
            counter.textContent = tpl.replace('%(count)s', fmtCount(total))
                .replace('%(place)s', label).replace('%(in_place)s', data.place_in || label);
        } else {
            var word = total === 1 ? window.JN.t('js.search2.journalist_singular') : window.JN.t('js.search2.journalist_plural');
            counter.textContent = fmtCount(total) + ' ' + word;
        }
    }

    function applyInterpretation(interp) {
        state.q = interp.q || undefined;
        if (!state.q) delete state.q;
        // a profession-only interpretation carries no place key; don't clobber an existing place chip
        if (interp.place) state.place = interp.place;
        interpProfession = interp.profession_id ? String(interp.profession_id) : null;
        if (interpProfession) {
            state.profession = state.profession || [];
            if (state.profession.indexOf(interpProfession) === -1) state.profession.push(interpProfession);
        }
    }

    function fetchResults(reset) {
        if (loading) return;
        if (reset) { state.page = 1; exhausted = false; }
        if (exhausted) return;
        loading = true;
        var preloader = document.getElementById('preloader');
        if (preloader) preloader.classList.remove('tw-hidden');
        var apiParams = toParams({page: state.page, per_page: 10, format: 'html',
                                  lang: document.documentElement.lang || 'en'});
        // hero surfaces tag their handoff with ?src=; forward it so page-1 audits carry it
        var src = new URLSearchParams(location.search).get('src');
        if (src && state.page === 1) apiParams.set('src', src);
        fetch('/a/search2?' + apiParams.toString())
            .then(function (r) { return r.json(); })
            .then(function (data) {
                if (reset) results.innerHTML = '';
                document.querySelector('.notfound').classList.add('tw-hidden');
                document.querySelector('.locked').classList.add('tw-hidden');
                if (data.interpretation) {
                    applyInterpretation(data.interpretation);
                    syncFiltersFromState();
                    renderChips();
                    updateBookBanner();
                }
                placeDisplay = (data.place_label && state.place)
                    ? {value: state.place, label: data.place_label} : null;
                if (placeDisplay) renderChips();
                showInterpretation(data.interpretation, data);
                showTranslation(data.translation);
                showPivot(data);
                if (data.status === 'success') {
                    results.insertAdjacentHTML('beforeend', data.data);
                    if (window.JN.pillFit) window.JN.pillFit(results);
                    setCounter(data.total_count, data);
                    if (data.facets) updateFacets(data.facets);
                    showLadder(data.ladder, data);
                    if (!data.item_count || results.children.length >= data.total_count) exhausted = true;
                    var banner = document.getElementById('post_a_job_banner');
                    if (banner) banner.style.display = data.total_count ? '' : 'none';
                } else if (data.status === 'restricted') {
                    exhausted = true;
                    document.querySelector('.locked').classList.remove('tw-hidden');
                } else {
                    exhausted = true;
                    setCounter(0, data);
                    if (data.facets) updateFacets(data.facets);
                    showLadder(data.ladder || {step: 3}, data);
                }
                if (reset && !suppressHistory) {
                    history.pushState('', document.title, '/search?' + toParams().toString());
                }
                suppressHistory = false;
            })
            .finally(function () {
                loading = false;
                if (preloader) preloader.classList.add('tw-hidden');
            });
    }

    function syncFiltersFromState() {
        document.querySelectorAll('input[data-filter]').forEach(function (input) {
            var kind = input.getAttribute('data-filter');
            if (MULTI[kind]) input.checked = (state[kind] || []).indexOf(input.value) !== -1;
        });
        updateFilterBadge();
    }

    function updateFilterBadge() {
        var badge = document.getElementById('active-filter-count');
        if (!badge) return;
        var count = (state.skill || []).length + (state.speaks || []).length + (state.profession || []).length;
        badge.textContent = count;
        badge.classList.toggle('tw-hidden', !count);
    }

    function stateIsEmpty() {
        return !Object.keys(state).some(function (k) {
            return !MODIFIERS[k] && state[k] && state[k].length !== 0;
        });
    }

    function refresh() {
        renderChips();
        updateBookBanner();
        fetchResults(true);
    }

    function addChip(type, value) {
        if (type === 'q' || type === 'place') {
            state[type] = value;
            delete state.exact;
            if (type === 'place') { delete state.lat; delete state.lng; delete state.place_mode; }
        } else {
            state[type] = state[type] || [];
            if (state[type].indexOf(value) === -1) state[type].push(value);
        }
    }

    root.addEventListener('jn:chip', function (e) {
        if (e.detail.type === 'combo') {
            Object.keys(e.detail.params).forEach(function (k) { addChip(k, e.detail.params[k]); });
        } else {
            addChip(e.detail.type, e.detail.value);
        }
        if (document.querySelector('.search-results')) {
            syncFiltersFromState();
            refresh();
        } else {
            window.location.href = '/search?' + toParams().toString();
        }
    });

    document.addEventListener('click', function (e) {
        var pivot = e.target.closest('#pivot-toggle');
        if (pivot) {
            if (state.place_mode === 'covers') delete state.place_mode;
            else state.place_mode = 'covers';
            delete state.lat; delete state.lng;
            refresh();
            return;
        }
        var undo = e.target.closest('#interpretation-undo');
        if (undo) {
            var banner = document.getElementById('interpretation-banner');
            state.q = banner.getAttribute('data-q-raw') || state.q;
            state.exact = '1';
            delete state.place; delete state.lat; delete state.lng; delete state.place_mode;
            if (interpProfession) {
                state.profession = (state.profession || []).filter(function (v) { return v !== interpProfession; });
                if (!state.profession.length) delete state.profession;
                interpProfession = null;
            }
            banner.classList.add('tw-hidden');
            syncFiltersFromState();
            refresh();
            return;
        }
        var btn = e.target.closest('[data-chip-type] button');
        if (!btn) return;
        var chipEl = btn.closest('[data-chip-type]');
        var type = chipEl.getAttribute('data-chip-type');
        var value = chipEl.getAttribute('data-chip-value');
        if (MULTI[type]) state[type] = (state[type] || []).filter(function (v) { return v !== value; });
        else {
            delete state[type];
            if (type === 'q') delete state.exact;
            if (type === 'place') { delete state.lat; delete state.lng; delete state.place_mode; }
        }
        if (stateIsEmpty()) {
            window.location.href = '/search';
            return;
        }
        syncFiltersFromState();
        refresh();
    });

    document.querySelectorAll('input[data-filter]').forEach(function (input) {
        input.addEventListener('change', function () {
            var kind = input.getAttribute('data-filter');
            state[kind] = Array.prototype.map.call(
                document.querySelectorAll('input[data-filter="' + kind + '"]:checked'),
                function (el) { return el.value; });
            if (!state[kind].length) delete state[kind];
            if (stateIsEmpty()) {
                window.location.href = '/search';
                return;
            }
            updateFilterBadge();
            refresh();
        });
    });

    var filterToggle = document.getElementById('filter-toggle');
    if (filterToggle) {
        filterToggle.addEventListener('click', function () {
            var rail = document.getElementById('filter-rail');
            var open = rail.classList.toggle('tw-hidden') === false;
            filterToggle.setAttribute('aria-expanded', String(open));
            var chevron = document.getElementById('filter-chevron');
            if (chevron) chevron.style.transform = open ? 'rotate(180deg)' : '';
        });
    }

    window.addEventListener('popstate', function () {
        suppressHistory = true;
        parseUrl();
        syncFiltersFromState();
        refresh();
    });

    var sentinel = document.getElementById('scroll-sentinel');
    if (sentinel && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting && !loading && !exhausted && results && results.children.length) {
                state.page += 1;
                fetchResults(false);
            }
        }, {rootMargin: '200px'}).observe(sentinel);
    }

    parseUrl();
    if (results) {
        syncFiltersFromState();
        renderChips();
        updateBookBanner();
        fetchResults(true);
    } else {
        renderChips();
    }
})();
